"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var clsx_1 = __importDefault(require("clsx"));
var colors_1 = require("../../colors");
var Text_1 = require("../Text");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    input: {
        backgroundColor: (0, colors_1.getColor)('WHITE_100'),
        border: "1px solid ".concat((0, colors_1.getColor)('BLACK_20')),
        borderRadius: '8px',
        boxSizing: 'border-box',
        color: (0, colors_1.getColor)('BLACK_100'),
        fontFamily: 'Poppins',
        height: '56px',
        lineHeight: '24px',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        padding: '16px',
        textTransform: 'none',
        width: '100%',
        '&:active': {
            borderColor: (0, colors_1.getColor)('DARK_PURPLE_100'),
        },
    },
    inputWithError: {
        borderColor: (0, colors_1.getColor)('RED_100'),
    },
    errorContainer: {
        marginTop: '8px',
    },
}); });
var Text = function (_a) {
    var className = _a.className, disabled = _a.disabled, onChange = _a.onChange, errorMessage = _a.errorMessage, placeholder = _a.placeholder, value = _a.value;
    var classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { className: (0, clsx_1.default)(classes.input, errorMessage ? classes.inputWithError : '', className), disabled: disabled, onChange: function (e) { return onChange(e.target.value); }, placeholder: placeholder || '', type: 'text', value: value }),
        errorMessage && (react_1.default.createElement("div", { className: classes.errorContainer },
            react_1.default.createElement(Text_1.Text, { color: 'RED_100', variant: 'small' }, errorMessage)))));
};
exports.Text = Text;
